import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.scss";
import openEyeImage from "../../assets/images/icons/eye.svg";
import closeEyeImage from "../../assets/images/icons/eye-no.svg";
import loginBackgroundMobile from "../../assets/images/background-images/login-background-mobile.png";
import Axios from "middleware/axiosInstance";
const Login = () => {
  const [userName, setUserName] = useState();
  const [password, setPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleLogin = async (e) => {
    e.preventDefault();
    // check internet connection
    if (!navigator.onLine) {
      alert("به اینترنت متصل نمی باشید");
    } else {
      try {
        const apiRoute = "login";
        await Axios.post(apiRoute, {
          phone: userName,
          password: password,
        })
          .then(async (response) => {
            await localStorage.setItem("token", response.data.data.api_token);
            await localStorage.setItem("name", response.data.data.name);
            await localStorage.setItem("post", response.data.data.post);
            await localStorage.setItem("loginMessage", true);
            navigate("/services");
          })
          .catch((err) => {
            alert("نام کاربری و رمز عبور را چک فرمایید");
          });
      } catch (e) {
        alert(e.message);
      }
    }
  };
  return (
    <div className="d-flex justify-content-between align-items-center flex-column login-main-container">
      {/* -------------- Start Fantasy Background Sun And Clouds -------------- */}

      <div className="sky-container">
        {/* start sun */}
        <div class="sun">
          <div class="outer"></div>
          <div class="inner"></div>
        </div>
        {/* end sun */}
        {/* start Clouds */}
        <div class="cloud cloud1">
          <div class="rect"></div>
          <div class="circle circle-lg"></div>
          <div class="circle circle-sm"></div>
        </div>
        <div class="cloud cloud2">
          <div class="rect"></div>
          <div class="circle circle-lg"></div>
          <div class="circle circle-sm"></div>
        </div>
        <div class="cloud cloud3">
          <div class="rect"></div>
          <div class="circle circle-lg"></div>
          <div class="circle circle-sm"></div>
        </div>
        <div class="cloud cloud4">
          <div class="rect"></div>
          <div class="circle circle-lg"></div>
          <div class="circle circle-sm"></div>
        </div>
        <div class="cloud cloud5">
          <div class="rect"></div>
          <div class="circle circle-lg"></div>
          <div class="circle circle-sm"></div>
        </div>
        {/* end Clouds */}
      </div>
      {/* -------------- end Fantasy Background Sun And Clouds -------------- */}

      <div className="company-logo-container">
        <span>بیستا</span>
        <span>تِک</span>
      </div>

      <div className="login-form-container">
        <form className="login-form" onSubmit={(e) => handleLogin(e)}>
          <input
            type="number"
            placeholder="نام کاربری"
            className="login-form-input disable-arrow-input"
            onChange={(e) => setUserName(e.target.value)}
          />
          {password
            ? password.length > 0 && (
                <label
                  className="login-form-lable-password"
                  htmlFor="password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <img
                    className="login-form-image-show-hide-password"
                    src={showPassword ? closeEyeImage : openEyeImage}
                    alt="icon"
                  />
                </label>
              )
            : null}
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="رمز عبور"
            className="login-form-input login-form-input-password"
            onChange={(e) => setPassword(e.target.value)}
          ></input>

          <button
            className="custom-button-blue login-form-button"
            type="submit"
          >
            ورود
          </button>
        </form>
        <div className="forget-password-container">
          <a href="tel:+982532176" className="forget-password">
            فعالسازی/فراموشی رمز
          </a>
        </div>
      </div>
      <div className="login-background-image page-content-center">
        <img src={loginBackgroundMobile} alt="background-image" />
      </div>
    </div>
  );
};
export default Login;
